import { render, staticRenderFns } from "./CommonTabs.vue?vue&type=template&id=6723d770&"
import script from "./CommonTabs.vue?vue&type=script&lang=js&"
export * from "./CommonTabs.vue?vue&type=script&lang=js&"
import style0 from "./CommonTabs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommonTabs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports